import {
  getWorkspaceUuidFromCurrentUrl,
  updateSelectedTableViewInLS,
} from "src/utils/methods";
import { valueExists } from "src/app/methods/valueExists";
import {
  SET_PROJECT_COLUMN_RANK,
  SET_PROJECT_FILTER,
  SET_PROJECT_FILTERS,
  SET_PROJECT_INITIAL_COLUMN_RANKS,
  SET_PROJECT_INITIAL_HIDDEN_COLUMNS,
  SET_PROJECT_SORT,
  SET_PROJECT_SORT_BY,
  SET_SELECTED_TABLE_VIEW,
  TOGGLE_PROJECTS_LIST_COLUMN_VISIBILITY,
} from "./projectFiltersTypes";
import {
  getFromLocalStorage,
  saveToLocalStorage,
} from "src/utils/localStorage";

const defaultSelectedTableView = {
  label: "Custom",
  value: null,
};

const wsWorkspaceUuid = getWorkspaceUuidFromCurrentUrl();

const getInitialState = () => {
  const settingsData = getFromLocalStorage("ws-projects-list-settings");

  const settings = settingsData ? settingsData[wsWorkspaceUuid] : null;

  const selectedTableView = settings?.selectedTableView;

  if (selectedTableView?.data) {
    return {
      ...settings,
      ...selectedTableView.data,
      selectedTableView,
    };
  }

  if (settings) return settings;

  return {
    sortBy: null,
    sort: "DESC",
    filters: [],
    hiddenColumns: [],
    projectColumnRanks: [],
    selectedTableView: defaultSelectedTableView,
  };
};

const save = (obj, skipLSUpdate) => {
  if (!skipLSUpdate) {
    saveToLocalStorage("ws-projects-list-settings", {
      ...getFromLocalStorage("ws-projects-list-settings"),
      [wsWorkspaceUuid]: obj,
    });
  }
  return sanitizeFilters(obj);
};

export const sanitizeFilters = (obj) => {
  // stupid but it works, gets rid of keys for undefined values
  return JSON.parse(JSON.stringify(obj));
};

export const removeHiddenSettings = (state, columnId) => {
  return {
    ...state,
    sortBy: state.sortBy === columnId ? undefined : state.sortBy,
    activeSortingColumn:
      state.activeSortingColumn === columnId
        ? undefined
        : state.activeSortingColumn,
    filters: { ...state.filters, [columnId]: undefined },
  };
};

// eslint-disable-next-line @typescript-eslint/default-param-last
function projectFiltersReducer(state = getInitialState(), action) {
  if (
    action?.payload?.data?.status === "fail" ||
    action?.error?.response?.status >= 500
  ) {
    return {
      ...state,
      errorMessages: [{ message: "An unexpected error occurred." }],
    };
  }
  switch (action.type) {
    case SET_PROJECT_SORT_BY:
      return save(
        {
          ...state,
          selectedTableView: defaultSelectedTableView,
          sortBy: action.payload.sortBy,
        },
        action.payload.skipLSUpdate,
      );

    case SET_PROJECT_SORT: {
      const resetTableView = Boolean(action?.payload?.sort !== state?.sort);
      return save(
        {
          ...state,
          selectedTableView: resetTableView
            ? defaultSelectedTableView
            : state.selectedTableView,
          sort: action.payload.sort,
        },
        action.payload.skipLSUpdate,
      );
    }

    case SET_PROJECT_FILTERS:
      return save(
        {
          ...state,
          selectedTableView: defaultSelectedTableView,
          filters: action.payload.filters,
        },
        action.payload.skipLSUpdate,
      );

    case SET_PROJECT_FILTER:
      return save({
        ...state,
        selectedTableView: defaultSelectedTableView,
        filters: {
          ...state.filters,
          [action.payload.fieldUuid]: !valueExists(action.payload.value)
            ? undefined
            : { value: action.payload.value },
        },
      });

    case SET_PROJECT_INITIAL_HIDDEN_COLUMNS:
      return save(
        {
          ...state,
          selectedTableView: defaultSelectedTableView,
          hiddenColumns: action.payload.hiddenColumns,
        },
        action.payload.skipLSUpdate,
      );

    case TOGGLE_PROJECTS_LIST_COLUMN_VISIBILITY:
      return save({
        // ...state,
        ...removeHiddenSettings(state, action.payload.uuid),
        selectedTableView: defaultSelectedTableView,
        hiddenColumns: state.hiddenColumns.includes(action.payload.uuid)
          ? state.hiddenColumns.filter((hc) => hc !== action.payload.uuid)
          : [...state.hiddenColumns, action.payload.uuid],
      });

    case SET_PROJECT_INITIAL_COLUMN_RANKS:
      if (action.payload.saveConfig) {
        save({
          ...state,
          selectedTableView: defaultSelectedTableView,
          projectColumnRanks: action.payload.ranks,
        });
      }

      return {
        ...state,
        projectColumnRanks: action.payload.ranks,
      };

    case SET_PROJECT_COLUMN_RANK: {
      const { uuid, rank } = action.payload;

      let foundRank = false;

      const newRanks = state.projectColumnRanks.map((col) => {
        if (col.uuid === uuid) {
          foundRank = true;
          return {
            ...col,
            rank,
          };
        }

        return col;
      });

      if (!foundRank) newRanks.push({ uuid, rank });

      return save({
        ...state,
        selectedTableView: defaultSelectedTableView,
        projectColumnRanks: newRanks,
      });
    }

    case SET_SELECTED_TABLE_VIEW:
      updateSelectedTableViewInLS(
        "ws-projects-list-settings",
        action.payload.selectedTableView,
      );
      return {
        ...state,
        selectedTableView: action.payload.selectedTableView,
      };

    default:
      return state;
  }
}

export default projectFiltersReducer;
